import classNames from 'classnames';
import './ClearBtn.scss';
import { Hint } from '@redoc/ui-kit';

interface IClearBtnProps extends React.HtmlHTMLAttributes<HTMLButtonElement> {
	notHint?: boolean;
	isClose?: boolean;
	disable?: boolean;
	title?: string;
	width?: number;
	height?: number;
}

const ClearBtn: React.FC<IClearBtnProps> = ({
	className,
	notHint = false,
	disable = false,
	title = '',
	width = 32,
	height = 32,
	isClose,
	...otherProps
}) => {
	const text = title ? title : isClose ? 'Закрыть' : 'Сбросить';
	return (
		<button
			type="button"
			disabled={disable}
			className={classNames('rdc_clearbtn', className)}
			{...otherProps}
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="10"
				height="10"
				viewBox="0 0 10 10"
				fill="none"
			>
				<path
					d="M9.19955 1.21384C9.47767 0.935724 9.47767 0.484811 9.19955 0.206696C8.92144 -0.0714187 8.47053 -0.0714184 8.19241 0.206697L4.70312 3.69598L1.21384 0.206696C0.935724 -0.0714189 0.484811 -0.0714185 0.206696 0.206696C-0.0714185 0.484811 -0.0714184 0.935724 0.206697 1.21384L3.69598 4.70312L0.206696 8.19241C-0.071419 8.47053 -0.0714187 8.92144 0.206696 9.19955C0.484811 9.47767 0.935725 9.47767 1.21384 9.19955L4.70312 5.71027L8.19241 9.19955C8.47053 9.47767 8.92144 9.47767 9.19955 9.19955C9.47767 8.92144 9.47767 8.47052 9.19955 8.19241L5.71027 4.70312L9.19955 1.21384Z"
					fill="#2196F3"
				/>
			</svg>
		</button>
	);
};

export default ClearBtn;
